import "bootstrap/dist/css/bootstrap.min.css";
import {Box, Grid, Typography} from '@mui/material';
import UpcomingGroupTourSections from "../components/./tours/UpcomingGroupTourSections";
import {useLanguage} from "../LanguageContext";
import PageHeader from "../components/PageHeader";

import image1 from "../images/tours/group.jpg";
import GroupTourGallerySection from "../components/tours/GroupTourGallerySection";
import {PageTitle} from "../components/PageTitle";
import React, {useEffect, useState} from "react";
import ContactSection from "../components/contact/ContactSection";
import ReactGA from "react-ga4";

const images = [
    image1,
];


const DestinationsPage = () => {
    const {t} = useLanguage();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    }, []);

    return (
        <Box>
            <PageTitle title={'label_destinations'}/>
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                }}
            >
                <PageHeader color={'#ffffff'} images={images}
                            content={{
                                title: 'destination_title',
                                // subtitle: 'destination_subtitle'
                            }}
                            setOpen={setOpen}/>

                <Box sx={{
                    position: 'relative',
                    p: '20px',
                    pt: '100px',
                    pb: '100px',
                    mx: "auto",
                    width: "100%",
                    minHeight: '60vh',
                    backgroundColor: '#FFFFFF',
                    color: "#000000",
                    alignContent: 'center',
                }}>
                    <Grid container spacing={4} alignItems="center"
                          justifyContent="center">

                        <Grid item
                              xs={12}
                              sm={12}
                              md={9}
                              lg={9}>
                            <Box sx={{
                                color: "#FFFFFF",
                            }}>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        pb: '24px',
                                    }}
                                >
                                    <Typography sx={{
                                        color: "black",
                                        fontSize: {
                                            xs: '24px',
                                            sm: '26px',
                                            md: '28px',
                                            lg: '30px',
                                        },
                                        fontFamily: 'ButlerLight',
                                    }}>
                                        {t('group_tour_title')}
                                    </Typography>
                                    <Typography sx={{
                                        color: "black",
                                        fontSize: {
                                            xs: '24px',
                                            sm: '26px',
                                            md: '28px',
                                            lg: '30px',
                                        },
                                        fontFamily: 'ButlerLight',
                                    }}>
                                        {t('group_tour_subtitle')}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: {
                                            xs: '100%',
                                            sm: '80%',
                                            md: '90%',
                                            lg: '60%',
                                        },
                                        ml: {
                                            xs: '0',
                                            sm: '10%',
                                            md: '5%',
                                            lg: '20%',
                                        }
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            marginTop: '12px',
                                            color:'black',
                                            fontFamily: "Jost-Regular",
                                            fontSize: '20px',
                                            textAlign: 'center',
                                        }}>
                                        {t('group_tour_subtitle_text')}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>


                <Box
                    sx={{
                        backgroundColor: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            p: '30px 0px 30px 0px',
                            backgroundColor: "#2E4D3D",
                        }}
                    >
                        <UpcomingGroupTourSections titleVariant={"white"}/>
                    </Box>
                </Box>
                <GroupTourGallerySection/>
                <ContactSection/>
                <ContactSection open={open} setOpen={setOpen}/>
            </Box>
        </Box>
    );
}

export default DestinationsPage;
